import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { filter, Observable, Subscription, tap } from "rxjs";
import { B2bUserService } from "../../services/b2b-user.service";
import { DefaultB2BUnit } from "../../models/user.model";
import { toObservable } from "@angular/core/rxjs-interop";

@Component({
  selector: 'app-location-strip',
  templateUrl: './location-strip.component.html',
  styleUrls: ['./location-strip.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocationStripComponent implements OnInit, OnDestroy {
  private readonly b2bUserService = inject(B2bUserService);

  usergetDataObj: DefaultB2BUnit;
  showLocStrip = signal(false);
  userSub: Subscription;
  private readonly $b2bUnit: Observable<DefaultB2BUnit>;

  constructor() {
    this.$b2bUnit = toObservable(this.b2bUserService.b2bUser);
  }

  ngOnInit() {
    this.userSub = this.$b2bUnit
      .pipe(
        tap(() => {
          this.showLocStrip.set(false);
        }),
        filter(Boolean)
      )
      .subscribe(b2bUser => {
        this.usergetDataObj = b2bUser;
        this.showLocStrip.set(true);
      });
  }

  ngOnDestroy(): void {
    this.userSub?.unsubscribe();
  }
}
